export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-exchange/huobi-60a643acb29c4e54d02924db8ba77de3.png";